import RegexValidator from './regex';

export default class Email extends RegexValidator {
  regex = /[^@]+@[^.]+\..+/;
}
